import { createReducer } from "deox";

import {
  clearAddChildData,
  loadedRollsForChildService,
  loadedRollsForChildServiceError,
  loadingRollsForChildService,
  rollOverLoaded,
  rollOverLoading,
  rollOverLoadingError,
  rollOverSaved,
  rollOverSaving,
  rollOverSavingError,
} from "./rollOverStateActions";
import { RollOverScheduleHttpResponse, RollOverStatusHttpResponse } from "../../parentApi";
import { purge } from "../purge/purgeStateActions";
export interface RaiseQueryState {
  isLoading: boolean;
  isLoadingError: boolean;
  isLoaded: boolean;
  isSaving: boolean;
  isSavingError: boolean;
  isSaved: boolean;
  rollOverSchedules: RollOverScheduleHttpResponse[] | null;
  isLoadingRollsForChild: boolean;
  isLoadingRollsForChildError: boolean;
  isRollsForChildLoaded: boolean;
  newRollOverSchedules: RollOverScheduleHttpResponse[] | null;
}

export const initialState: RaiseQueryState = {
  isLoading: false,
  isLoadingError: false,
  isLoaded: false,
  isSaving: false,
  isSavingError: false,
  isSaved: false,
  rollOverSchedules: null,
  isLoadingRollsForChild: false,
  isLoadingRollsForChildError: false,
  isRollsForChildLoaded: false,
  newRollOverSchedules: null,
};

const rollOverReducer = createReducer(initialState, (handleAction) => [
  handleAction(
    rollOverLoading,
    (state): RaiseQueryState => ({
      ...state,
      isLoading: true,
      isLoadingError: false,
      isLoaded: false,
      isSaving: false,
      isSavingError: false,
      isSaved: false,
      isLoadingRollsForChild: false,
      isLoadingRollsForChildError: false,
      isRollsForChildLoaded: false,
    })
  ),
  handleAction(
    rollOverLoadingError,
    (state): RaiseQueryState => ({
      ...state,
      isLoading: false,
      isLoadingError: true,
      isLoaded: false,
      isSaving: false,
      isSavingError: false,
      isSaved: false,
      isLoadingRollsForChild: false,
      isLoadingRollsForChildError: false,
      isRollsForChildLoaded: false,
    })
  ),
  handleAction(
    rollOverLoaded,
    (state, action): RaiseQueryState => ({
      ...state,
      isLoading: false,
      isLoadingError: false,
      isLoaded: true,
      isSaving: false,
      isSavingError: false,
      isSaved: false,
      isLoadingRollsForChild: false,
      isLoadingRollsForChildError: false,
      isRollsForChildLoaded: false,
      rollOverSchedules: action.payload,
    })
  ),
  handleAction(
    rollOverSaving,
    (state): RaiseQueryState => ({
      ...state,
      isLoading: false,
      isLoadingError: false,
      isLoaded: false,
      isSaving: true,
      isSavingError: false,
      isSaved: false,
      isLoadingRollsForChild: false,
      isLoadingRollsForChildError: false,
      isRollsForChildLoaded: false,
    })
  ),
  handleAction(
    rollOverSavingError,
    (state): RaiseQueryState => ({
      ...state,
      isLoading: false,
      isLoadingError: false,
      isLoaded: false,
      isSaving: false,
      isSavingError: true,
      isSaved: false,
      isLoadingRollsForChild: false,
      isLoadingRollsForChildError: false,
      isRollsForChildLoaded: false,
    })
  ),
  handleAction(
    rollOverSaved,
    (state, action): RaiseQueryState => ({
      ...state,
      isLoading: false,
      isLoadingError: false,
      isLoaded: false,
      isSaving: false,
      isSavingError: false,
      isSaved: true,
      rollOverSchedules: action.payload,
      isLoadingRollsForChild: false,
      isLoadingRollsForChildError: false,
      isRollsForChildLoaded: false,
    })
  ),
  handleAction(
    loadingRollsForChildService,
    (state): RaiseQueryState => ({
      ...state,
      isLoading: true,
      isLoadingError: false,
      isLoaded: false,
      isSaving: false,
      isSavingError: false,
      isSaved: false,
      newRollOverSchedules: [],
      isLoadingRollsForChild: true,
      isLoadingRollsForChildError: false,
      isRollsForChildLoaded: false,
    })
  ),
  handleAction(
    loadedRollsForChildServiceError,
    (state): RaiseQueryState => ({
      ...state,
      isLoading: false,
      isLoadingError: true,
      isLoaded: false,
      isSaving: false,
      isSavingError: false,
      isSaved: false,
      isLoadingRollsForChild: false,
      isLoadingRollsForChildError: true,
      isRollsForChildLoaded: false,
    })
  ),
  handleAction(
    clearAddChildData,
    (state): RaiseQueryState => ({
      ...state,
      isLoadingRollsForChild: false,
      isLoadingRollsForChildError: false,
      isRollsForChildLoaded: false,
      newRollOverSchedules: [],
    })
  ),
  handleAction(loadedRollsForChildService, (state, action) => {
    const child = action.payload.child;
    const childId = child.childId!;
    const rollsForChild = action.payload.rollsForChild ?? [];

    const newRollOverSchedules: RollOverScheduleHttpResponse[] = [];

    rollsForChild?.forEach((roll) => {
      if (roll.sessionType === "BSC" || roll.sessionType === "ASC") {
        const currentYear = new Date().getFullYear() + 1;

        const newSchedule = new RollOverScheduleHttpResponse();
        newSchedule.childId = childId;
        newSchedule.rollId = roll.rollId;
        newSchedule.careTypeId = roll.sessionType === "BSC" ? 3 : 4;
        newSchedule.frequencyTypeId = 1;
        newSchedule.mon1 = false;
        newSchedule.tue1 = false;
        newSchedule.wed1 = false;
        newSchedule.thu1 = false;
        newSchedule.fri1 = false;
        newSchedule.mon2 = false;
        newSchedule.tue2 = false;
        newSchedule.wed2 = false;
        newSchedule.thu2 = false;
        newSchedule.fri2 = false;
        newSchedule.forYear = currentYear;
        newSchedule.cohortStatus = RollOverStatusHttpResponse.Undefined;
        newSchedule.rollOverStatus = RollOverStatusHttpResponse.Undefined;
        newSchedule.rollName = roll.rollName!;
        newSchedule.serviceId = roll.serviceId;
        newSchedule.serviceName = child.serviceName!;
        newSchedule.firstName = child.firstName!;
        newSchedule.lastName = child.lastName!;

        newRollOverSchedules.push(newSchedule);
      }
    });

    newRollOverSchedules.sort((a, b) => (a.careTypeId % 100) - (b.careTypeId % 100));

    return {
      ...state,
      newRollOverSchedules: newRollOverSchedules,
      isLoading: false,
      isLoadingError: false,
      isLoaded: true,
      isSaving: false,
      isSavingError: false,
      isSaved: false,
      isLoadingRollsForChild: false,
      isLoadingRollsForChildError: false,
      isRollsForChildLoaded: true,
    };
  }),

  handleAction(purge, () => initialState),
]);

export default rollOverReducer;
